module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Maisprach-cceb3a7c3487c291c9b145b2cad5fd01.svg";